"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginPage = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const application_config_1 = __importDefault(require("../../config/application.config"));
const LoginForm_1 = __importDefault(require("../forms/auth/localLogin/LoginForm"));
const react_router_1 = require("react-router");
const LoginPage = (props) => {
    var _a, _b, _c, _d;
    const navigate = (0, react_router_1.useNavigate)();
    react_1.default.useEffect(() => {
        if (props.isAuthenticated) {
            navigate(application_config_1.default.homePage);
        }
    }, []);
    const allowRegistration = props.config.allowRegistration !== false && ((_b = (_a = props.config.auth) === null || _a === void 0 ? void 0 : _a.localLogin) === null || _b === void 0 ? void 0 : _b.allowRegistration) !== false;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(LoginForm_1.default, { withForgotPassword: props.config.forgotPasswordPage === true ||
                ((_d = (_c = props.config.auth) === null || _c === void 0 ? void 0 : _c.localLogin) === null || _d === void 0 ? void 0 : _d.forgotPasswordPage) === true }),
        react_1.default.createElement("div", { className: "apptr__separator-medium" }),
        react_1.default.createElement("div", { className: "apptr__footer-link-container" }, allowRegistration && (react_1.default.createElement("a", { className: "register-link _oblique", href: "/register" }, props.t('auth:registerIfYouHaveNoAccount'))))));
};
exports.LoginPage = LoginPage;
const mapStateToProps = (state) => {
    return { isAuthenticated: state.auth.isAuthenticated, login: state.auth.login };
};
exports.default = (0, react_redux_1.connect)(mapStateToProps)((0, react_i18next_1.withTranslation)('auth')(exports.LoginPage));
//# sourceMappingURL=LoginPage.js.map